import * as types from './mutation-types'
import {UserValidate} from '@/validate'
import {api} from '@/service/api'
import session from '@/libs/session'
import {Message} from 'element-ui'
import Cookies from 'js-cookie'
import {API_BASE_URL, TOKEN_KEY} from '@/config/app'

export const actions = {
  async login ({dispatch,commit}, o) {
    const form = {
      mobile: o.mobile,
      password: o.password,
      smscode: o.smscode
    }
    let validate = new UserValidate('login').check(form)
    if (validate.success) {
      let res = await api.user.login(form)
      if(!res){
        Message.error('你的账号在另一个地方登录!')
        return
      }
      if (res.success) {
        if(res.errno == 0){
          session.setToken(res.data.token)
          session.setChatToken(res.data.token)
          let res1 = await dispatch('getUserInfo')
          Message.success('登陆成功');
          return res1
        }else{
          return res
        }
      } else {
        Message.error(res.msg);
      }
    } else {
      Message.warning(validate.errorMsg)
    }
  },
  async register ({dispatch}, o) {
    const form = {
      mobile: o.mobile,
      password: o.password,
      surePassword:  o.surePassword,
      recomId:  o.recomId
    }
    let validate = new UserValidate('login').check(form)
    if (validate.success) {
      let res = await api.user.register(form)
      if(!res){
        Message.error('你的账号在另一个地方登录!')
        return
      }
      session.clearToken()
      if (res.success) {
        return res
      } else {
        Message.error(res.msg)
      }
    } else {
      Message.error(validate.errorMsg)
    }
  },  
  async wechatLogin ({dispatch}, s) {
    const form = {
      code: s
    }
    let res = await api.user.wechatLogin(form)
    if(!res){
      Message.error('你的账号在另一个地方登录!')
      return
    }
    if (res.success) {
      session.setToken(res.data.token)
      let res1 = await dispatch('getUserInfo')
      return res1
    } else {
      Message.error(res.msg)
    }
  },
  async getUserInfo ({commit}) {
    if (session.isLogin()) {
      let res = await api.user.getUserInfo()
      if(!res){
        Message.error('你的账号在另一个地方登录!')
        return
      }
      if (res.success) {
        commit(types.INIT_USER_INFO, res.data)
        commit(types.SET_LOGIN_STATE, true)
        return res.data
      } else {
        Message.error(res.msg)
      }
    }
  },
  async editUserInfo ({dispatch}, o) {
    const form = {
      nickname: o.nickname,
      qq: o.qq,
      weixin: o.weixin,
      email: o.email,
      address: o.address,
      smsVerify:o.smsVerify
    }    
    let res = await api.user.editUserInfo(form)
    if (res.success) {
      let res1 = await dispatch('getUserInfo')
      // Message.success('修改成功')
      return true
    } else {
      Message.error(res.msg)
    }
  },
  async itemList ({commit},o) {
    const form = {
      page: o.page,
      limit: o.limit,
      sidx: o.sidx,
      order: o.order
    }        
    let res = await api.user.itemList(form)
    if (res.success) {
      return res.data
    } else {
      toast(res.msg, 'warn')
    }
  },
  async editUserInfo_area ({dispatch}, o) {   
    let res = await api.user.editUserInfo(o)
    if (res.success) {
      Message.success('提交成功')
      return true
    } else {
      Message.error(res.msg)
    }
  },
  async queryTodayRankingList ({commit}) {
    let res = await api.user.queryTodayRankingList()
    if (res.success) {
      return res.data
    } else {
      Message.error(res.msg)
    }
  }, 
  async queryYesterdayRankingList ({commit}) {
    let res = await api.user.queryYesterdayRankingList()
    if (res.success) {
      return res.data
    } else {
      Message.error(res.msg)
    }
  },
  async gameDetailList ({commit}) {
    let res = await api.user.gameDetailList()
    if (res.success) {
      return res.data
    } else {
      Message.error(res.msg)
    }
  },
  async rechargeList ({commit},o) {
    let res = await api.user.rechargeList(o)
    if (res.success) {
      return res.data
    } else {
      Message.error(res.msg)
    }
  },
  async redeemApplyList ({commit},o) {
    let res = await api.user.redeemApplyList(o)
    if (res.success) {
      return res.data
    } else {
      Message.error(res.msg)
    }
  },
  async queryRedeemApplyList ({commit},o) {
    let res = await api.user.queryRedeemApplyList(o)
    if (res.success) {
      return res.data
    } else {
      Message.error(res.msg)
    }
  },  
  async redeemApply ({commit},o) {
    let res = await api.user.redeemApply(o)
    if (res.success) {
      return res.data
    } else {
      Message.error(res.msg)
    }
  },
  async saveBankAction ({dispatch},o) {
    let res = await api.user.saveBankAction(o)
    if (res.success) {
      let res1 = await dispatch('getUserInfo')
      return res.data
    } else {
      Message.error(res.msg)
    }
  },
  async goodsList ({commit},o) {
    let res = await api.user.goodsList(o)
    if (res.success) {
      return res.data.goodsList
    } else {
      Message.error(res.msg)
    }
  },
  async goodsListDetail ({commit},o) {
    let res = await api.user.goodsListDetail(o)
    if (res.success) {
      return res.data
    } else {
      Message.error(res.msg)
    }
  },
  async rebateDetail ({commit},o) {
    let res = await api.user.rebateDetail(o)
    if (res.success) {
      return res.data
    } else {
      Message.error(res.msg)
    }
  },  
  async toBaseProp ({commit},o) {
    let res = await api.user.toBaseProp(o)
    if(!res){
      Message.error('你的账号在另一个地方登录!')
      return
    }
    if (res.success) {
      return res.data
    } else {
      Message.error(res.msg, 'warn')
    }
  },
  async toPillProp ({commit},o) {
    let res = await api.user.toPillProp(o)
    if(!res){
      Message.error('你的账号在另一个地方登录!')
      return
    }
    if (res.success) {
      return res.data
    } else {
      Message.error(res.msg, 'warn')
    }
  },
  async getUserOrder ({commit}, o) {
    let res = await api.user.getUserOrder()
    if(!res){
      Message.error('你的账号在另一个地方登录!')
      return
    }
    if (res.success) {
      // @TODO
    } else {
      Message.error(res.msg)
    }
  },
  async logout ({commit}) {
    session.clearToken()
    Message.success('退出成功')
    window.location.href = '/'
  },
  async sendLetter ({dispatch}, o) {
    const form = {
      receiver: o.receiver,
      topic: o.topic,
      content: o.content
    }
    let validate = new UserValidate('sendLetter').check(form)
    if (validate.success) {
      let res = await api.user.sendStationLetter(form)
      if(!res){
        Message.error('你的账号在另一个地方登录!')
        return
      }
      if (res.success) {
        return res
      } else {
        Message.error(res.msg)
      }
    } else {
      Message.error(validate.errorMsg)
    }
  },
  async getLetters ({commit}) {
    let res = await api.user.getLetters()
    if(!res){
      Message.error('你的账号在另一个地方登录!')
      return
    }
    if (res.success) {
      commit(types.INIT_GETLETTERLIST, res.data)
      return res.data
    } else {
      Message.error(res.msg)
    }
  },
  async getSendLetters ({commit}) {
    let res = await api.user.sendLetters()
    if(!res){
      Message.error('你的账号在另一个地方登录!')
      return
    }
    if (res.success) {
      commit(types.INIT_SENDLETTERLIST, res.data)
      return res.data
    } else {
      Message.error(res.msg)
    }
  },
  async getRecordList ({commit}, o) {
    const form = {
      page: o.page,
      limit: o.limit,
      sidx: o.sidx,
      order: o.order
    }    
    let res = await api.user.accountRecordList(form)
    if(!res){
      Message.error('你的账号在另一个地方登录!')
      return
    }
    if (res.success) {
      return res.data
    } else {
      Message.error(res.msg)
    }
  },  
  async queryRebateList ({commit}, o) {
    const form = {
      page: o.page,
      limit: o.limit,
      sidx: o.sidx,
      order: o.order,
      userNewId: o.userNewId
    }    
    let res = await api.user.queryRebateList(form)
    if(!res){
      Message.error('你的账号在另一个地方登录!')
      return
    }
    if (res.success) {
      return res.data
    } else {
      Message.error(res.msg)
    }
  },      
  async editComplain ({dispatch}, o) {
    const form = {
      topic: o.topic,
      content: o.content
    }
    let validate = new UserValidate('editComplain').check(form)
    if (validate.success) {
      let res = await api.user.editComplain(form)
      if(!res){
        Message.error('你的账号在另一个地方登录!')
        return
      }
      if (res.success) {
        return res
      } else {
        Message.error(res.msg)
      }
    } else {
      Message.error(validate.errorMsg)
    }
  },  
  async getComplainList ({commit}) {
    let res = await api.user.complainList()
    if(!res){
      Message.error('你的账号在另一个地方登录!')
      return
    }
    if (res.success) {
      commit(types.INIT_COMPLAINLIST, res.data)
      return res.data
    } else {
      Message.error(res.msg)
    }
  },         
  async getHelpList ({commit}) {
    let res = await api.user.helpList()
    if(!res){
      Message.error('你的账号在另一个地方登录!')
      return
    }
    if (res.success) {
      return res.data
    } else {
      Message.error(res.msg, 'warn')
    }
  },
  async sign ({dispatch}, o) {
    let res = await api.user.sign()
    if(!res){
      Message.error('你的账号在另一个地方登录!')
      return
    }
    if (res.success) {
      Message.success('签到成功')
      return true
    } else {
      if(res.code == 500){
         sessionStorage.signed = '1';
      }
      //Message.error(res.msg)
      return false
    }
  },  
  async signOrNot ({dispatch}, o) {
    let res = await api.user.signOrNot()
    if(!res){
      Message.error('你的账号在另一个地方登录!')
      return
    }
    if (res.success) {
      let res1 = await dispatch('sign')
      if(res1.success){
        //Message.success('签到成功')
        return true
      }else{
        return false
      }
    } else {
      Message.error(res.msg, 'warn')
    }
  }, 
  async querySignData ({commit}) {
    let res = await api.user.querySignData()
    if(!res){
      Message.error('你的账号在另一个地方登录!')
      return
    }
    if (res.success) {
      return res.data
    } else {
      Message.error(res.msg, 'warn')
    }
  },
  async secretSetting ({dispatch}, o) {
    const form = {
      questionId: o.questionId,
      answer: o.answer
    }
    let res = await api.user.secretSetting(form)
    if(!res){
      Message.error('你的账号在另一个地方登录!')
      return
    }
    if (res.success) {
      return res
    } else {
      Message.error(res.msg, 'warn')
    }
  },   
  async changeLoginPassword ({dispatch}, o) {
    const form = {
      answer: o.answer,
      oldPassword: o.oldPassword,
      password: o.password
    }
    let res = await api.user.changeLoginPassword(form)
    if(!res){
      Message.error('你的账号在另一个地方登录!')
      return
    }
    if (res.success) {
      return res
    } else {
      Message.error(res.msg, 'warn')
    }
  },     
  async changeBankOrCardPassword ({dispatch}, o) {
    const form = {
      type: o.type,
      mobile: o.mobile,
      password: o.password
    }
    let res = await api.user.changeBankOrCardPassword(form)
    if(!res){
      Message.error('你的账号在另一个地方登录!')
      return
    }
    if (res.success) {
      return res
    } else {
      Message.error(res.msg)
    }
  },
  async queryGameList ({commit,dispatch}, o) {
    const form = {
      page: o.page,
      limit: o.limit,
      sidx: o.sidx,
      order: o.order,
      type: o.type
    }
    let res = await api.user.queryGameList(form)
    if(!res){
      Message.error('你的账号在另一个地方登录!')
      return
    }
    if (res.success) {
      commit(types.INIT_GAMEDATALIST, res.data)
      let res1 = await dispatch('getUserInfo')
      return res.data
    } else {
      Message.error(res.msg)
    }
  },    
  async queryMapGameList ({commit}, o) {
    const form = {
      page: o.page,
      limit: o.limit,
      sidx: o.sidx,
      order: o.order,
      type: o.type
    }
    let res = await api.user.queryGameMapList(form)
    if(!res){
      Message.error('你的账号在另一个地方登录!')
      return
    }
    if (res.success) {
      commit(types.INIT_GAMEMAPDATALIST, res.data)
      return res.data
    } else {
      Message.error(res.msg)
    }
  },    
  async addmodeAction ({dispatch}, o) { 
    const form = {
      modename: o.modename,
      gt: o.gt,
      act: o.act,
      smoneysum: o.smoneysum,
      smoneyarr: o.smoneyarr,
      unid: o.unid
    }    
    let res = await api.user.addmodeAction(form)
    if(!res){
      Message.error('你的账号在另一个地方登录!')
      return
    }
    if (res.success) {
      Message.success('竞猜模式保存成功！')
      return true
    } else {
      Message.error(res.msg)
    }
  },
  async delmode ({dispatch}, o) { 
    const form = {
      unid: o.id
    }    
    let res = await api.user.delmode(form)
    if(!res){
      Message.error('你的账号在另一个地方登录!')
      return
    }
    if (res.success) {
      Message.success('删除竞猜模式成功！')
      return true
    } else {
      Message.error(res.msg)
    }
  },  
  async getUserModesEdit ({dispatch}, o) { 
    const form = {
      unid: o.id,
      type: o.type,
      modes: o.modes,
      action: o.action
    }    
    let res = await api.user.getUserModesEdit(form)
    if(!res){
      Message.error('你的账号在另一个地方登录!')
      return
    }
    if (res.success) {
      return res.data
    } else {
      Message.error(res.msg)
    }
  },    
  async addBetting ({dispatch}, o) { 
    const form = {
      bnum: o.bnum,
      gt: o.gt,
      smoneysum: o.smoneysum,
      smoneyarr: o.smoneyarr,
      dateline: o.dateline
    }    
    let res = await api.user.addBetting(form)
    if(!res){
      Message.error('你的账号在另一个地方登录!')
      return
    }
    if (res.success) {
      return res
    } else {
      Message.error(res.msg, 'warn')
    }
  },   
  async getUserBettingHistory ({commit}, o) {
    const form = {
      type: o.gt
    }      
    let res = await api.user.getUserBettingHistory(form)
    if(!res){
      Message.error('你的账号在另一个地方登录!')
      return
    }
    if (res.success) {
      return res.data
    } else {
      Message.error(res.msg, 'warn')
    }
  },   
  async getGameBtnDetailByNum ({commit}, o) {
    const form = {
      orderId: o.orderId,
      gt: o.gt
    }      
    let res = await api.user.getGameBtnDetailByNum(form)
    if(!res){
      Message.error('你的账号在另一个地方登录!')
      return
    }
    if (res.success) {
      return res.data
    } else {
      Message.error(res.msg, 'warn')
    }
  },      
  async getGameBtnDetailByPeriod ({commit}, o) {
    const form = {
      period: o.period,
      gt: o.gt
    }      
    let res = await api.user.getGameBtnDetailByPeriod(form)
    if (res.success) {
      return res.data
    } else {
      //toast(res.msg, 'warn')
    }
  },     
  async getUserModesList ({commit}, o) {
    const form = {
      page: o.page,
      limit: o.limit,
      sidx: o.sidx,
      order: o.order,
      type: o.type
    }      
    let res = await api.user.getUserModesList(form)
    if(!res){
      Message.error('你的账号在另一个地方登录!')
      return
    }
    if (res.success) {
      return res.data
    } else {
      Message.error(res.msg, 'warn')
    }
  },   
  async getAutoLastNum ({commit}, o) {
    const form = {
      type: o.type
    }      
    let res = await api.user.getAutoLastNum(form)
    if(!res){
      Message.error('你的账号在另一个地方登录!')
      return
    }
    if (res.success) {
      return res.data
    } else {
      Message.error(res.msg, 'warn')
    }
  },  
  async getAutoFitSetMode ({commit}, o) {
    const form = {
      type: o.type
    }      
    let res = await api.user.getAutoFitSetMode(form)
    if (res.success) {
      return res.data
    } else {
      Message.error(res.msg, 'warn')
    }
  },           
  async doAutoFitEdit ({commit}, o) {
    const form = {
      type: o.type,
      startNum: o.startNum,
      stopNum:o.stopNum,
      topCoin:o.topCoin,
      lowCoin:o.lowCoin,
      modelArr:o.modelArr,
      isUse:o.isUse,
      id:o.id
    }      
    let res = await api.user.doAutoFitEdit(form)
    if(!res){
      Message.error('你的账号在另一个地方登录!')
      return
    }
    if (res.success) {
      return res.data
    } else {
      Message.error(res.msg, 'warn')
    }
  },    
  async doAutoSetEdit ({commit}, o) {
    const form = {
      type: o.type,
      startNum: o.startNum,
      stopNum:o.stopNum,
      topCoin:o.topCoin,
      lowCoin:o.lowCoin,
      modelArr:o.modelArr,
      isUse:o.isUse,
      id:o.id
    }      
    let res = await api.user.doAutoSetEdit(form)
    if (res.success) {
      return res.data
    } else {
      Message.error(res.msg, 'warn')
    }
  },  
  async getWinTimerInfo ({commit}, o) {
    const form = {
      type: o.type
    }      
    let res = await api.user.getWinTimerInfo(form)
    if (res.success) {
      return res.data
    } else {
      Message.error(res.msg, 'warn')
    }
  },  
  async isOpened ({commit}, o) {
    const form = {
      type: o.type,
      num: o.num
    }      
    let res = await api.user.isOpened(form)
    if(!res){
      Message.error('你的账号在另一个地方登录!')
      return
    }
    if (res.success) {
      return res.data
    } else {
      Message.error(res.msg, 'warn')
    }
  },
  async getLastTzInfo ({commit}, o) {
    const form = {
      type: o.type,
      period:o.period
    }      
    let res = await api.user.getLastTzInfo(form)
    if (res.success) {
      return res.data
    } else {
      Message.error(res.msg, 'warn')
    }
  },  
  async getWinLoseInfo ({commit}, o) {
    const form = {
      type: o.type
    }      
    let res = await api.user.getWinLoseInfo(form)
    if(!res){
      Message.error('你的账号在另一个地方登录!')
      return res
    }
    if (res.success) {
      return res.data
    } else {
      Message.error(res.msg, 'warn')
    }
  },    
  async receiveRelief ({dispatch}, o) {
    let res = await api.user.receiveRelief()
    if(!res){
      Message.error('你的账号在另一个地方登录!')
      return
    }
    if (res.success) {
      return res
    } else {
      Message.error(res.msg, 'warn')
    }
  },   
  async queryFlow ({commit}, o) { 
    let res = await api.user.queryFlow()
    if (res.success) {
      return res.data
    } else {
      Message.error(res.msg, 'warn')
    }
  },         
  async sysLogin ({dispatch}, o) {
    const form = {
      username: o.username,
      password: o.password,
      captcha: o.captcha
    }
    let res = await api.user.sysLogin(form)
    return res
  },  
  async queryFirstRecharge ({commit}, o) { 
    let res = await api.user.queryFirstRecharge()
    if (res.success) {
      return res.data
    } else {
      Message.error(res.msg, 'warn')
    }
  },    
  async getMyAllSy ({commit}, o) { 
    let res = await api.user.getMyAllSy()
    if (res.success) {
      return res.data
    } else {
      Message.error(res.msg, 'warn')
    }
  },     
  async queryCashBack ({commit}, o) { 
    let res = await api.user.queryCashBack()
    if (res.success) {
      return res.data
    } else {
      Message.error(res.msg, 'warn')
    }
  },     
  async updateCashBack ({commit}, o) { 
    let res = await api.user.updateCashBack()
    if (res.success) {
      return res
    } else {
      Message.error(res.msg, 'warn')
    }
  },       
  async queryDownList ({commit}, o) { 
    let res = await api.user.queryDownList()
    if (res.success) {
      return res.data
    } else {
      Message.error(res.msg, 'warn')
    }
  },      
  async queryWeekLoss ({commit}, o) { 
    let res = await api.user.queryWeekLoss()
    if (res.success) {
      return res.data
    } else {
      Message.error(res.msg, 'warn')
    }
  },        
  async updateMbSet ({dispatch}, o) {
    const form = {
      radio: o.radio
    }    
    let res = await api.user.updateMbSet(form)
    if (res.success) {
      let res1 = await dispatch('getUserInfo')
      return true
    } else {
      Message.error(res.msg)
    }
  },
  async onGetWage ({commit}, o) { 
    let res = await api.user.onGetWage()
    if (res.success) {
      return res
    } else {
      Message.error(res.msg, 'warn')
    }
  },   
  async getWage ({commit}, o) { 
    let res = await api.user.getWage()
    if (res.success) {
      return res
    } else {
      Message.error(res.msg, 'warn')
    }
  }, 
  async getUseItem ({commit}, o) { 
    let res = await api.user.getUseItem()
    if (res.success) {
      return res
    } else {
      Message.error(res.msg, 'warn')
    }
  },     
  async drawFirstRecharge ({commit},o) {
    const form = {
      page: o.page,
      limit: o.limit,
      sidx: o.sidx,
      order: o.order
    }        
    let res = await api.user.drawFirstRecharge(form)
    if (res.success) {
      return res.data
    } else {
      toast(res.msg, 'warn')
    }
  },    
  async drawFirst ({dispatch}, o) {
    const form = {
      id: o.id
    }    
    let res = await api.user.drawFirst(form)
    if (res.success) {
      let res1 = await dispatch('getUserInfo')
      return res
    } else {
      Message.error(res.msg)
    }
  }, 
  async getGameStatus ({dispatch}, o) {
    const form = {
      type: o.type
    }    
    let res = await api.user.getGameStatus(form)
    if(!res){
      Message.error('你的账号在另一个地方登录!')
      return res
    }
    if (res.success) {
      return res
    } else {
      Message.error(res.msg)
    }
  }, 
  async queryLossBackStatus ({dispatch}, o) {
    let res = await api.user.queryLossBackStatus()
    if (res.success) {
      return res
    } else {
      Message.error(res.msg)
    }
  }, 
  async queryFirstStatus ({dispatch}, o) {
    let res = await api.user.queryFirstStatus()
    if (res.success) {
      return res
    } else {
      Message.error(res.msg)
    }
  },    
  async smsVerify ({dispatch}, o) {
    let res = await api.user.smsVerify(o)
    if (res.success) {
      session.setToken(res.data.token)
      session.setChatToken(res.data.token)      
      let res1 = await dispatch('getUserInfo')
      Message.success('登陆成功');
      return res1
    } else {
      Message.error(res.msg);
    }
  },  
  async toBeBanker ({dispatch}, o) { 
    const form = {
      period: o.period,
      type: o.type
    }    
    let res = await api.user.toBeBanker(form)
    if(!res){
      Message.error('你的账号在另一个地方登录!')
      return
    }
    if (res.success) {
      return res
    } else {
      Message.error(res.msg, 'warn')
    }
  },      
  async addBettingNiu ({dispatch}, o) { 
    const form = {
      period: o.period,
      type: o.type,
      btnType: o.btnType,
      btnCoins: o.btnCoins,
      dateline: o.dateline
    }    
    let res = await api.user.addBettingNiu(form)
    if(!res){
      Message.error('你的账号在另一个地方登录!')
      return
    }
    if (res.success) {
      return res
    } else {
      Message.error(res.msg, 'warn')
    }
  },   
  async queryCanadaNiuRecord ({dispatch}, o) { 
    const form = {
      period: o.period,
      type: o.type,
      btnType: o.btnType
    }    
    let res = await api.user.queryCanadaNiuRecord(form)
    if(!res){
      Message.error('你的账号在另一个地方登录!')
      return
    }
    if (res.success) {
      return res
    } else {
      Message.error(res.msg, 'warn')
    }
  },     
  async getUserBettingNiuHistory ({dispatch}, o) { 
    const form = {
      type: o.type
    }    
    let res = await api.user.getUserBettingNiuHistory(form)
    if(!res){
      Message.error('你的账号在另一个地方登录!')
      return
    }
    if (res.success) {
      return res
    } else {
      Message.error(res.msg, 'warn')
    }
  },
  async queryAgent ({commit}, o) { 
    let res = await api.user.queryAgent()
    if (res.success) {
      return res.data
    } else {
      Message.error(res.msg, 'warn')
    }
  },      
  async recharge ({dispatch}, o) { 
    const form = {
      amount: o.amount,
      agentId: o.agentId,
      type: o.type
    }    
    let res = await api.user.recharge(form)
    if(!res){
      Message.error('你的账号在另一个地方登录!')
      return
    }
    if (res.success) {
      return res
    } else {
      Message.error(res.msg, 'warn')
    }
  },
  async queryMyRecom ({commit}, o) { 
    let res = await api.user.queryMyRecom()
    if (res.success) {
      return res.data
    } else {
      Message.error(res.msg, 'warn')
    }
  },  
  async saveRecomRate ({dispatch}, o) { 
    const form = {
      userId: o.userId,
      rate: o.rebate
    }    
    let res = await api.user.saveRecomRate(form)
    if(!res){
      Message.error('你的账号在另一个地方登录!')
      return
    }
    if (res.success) {
      return res
    } else {
      Message.error(res.msg, 'warn')
    }
  },
  async drawYesterday ({commit}, o) { 
    let res = await api.user.drawYesterday()
    if (res.success) {
      return res
    } else {
      Message.error(res.msg, 'warn')
    }
  },                                                           
}



// WEBPACK FOOTER //
// ./src/logic/user/actions.js